import { Flex } from "antd";
import styled from "styled-components";

export const StyledScheduleFormWrapper = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    width: 100%;
    padding: 16px;
    background-color: ${(props) => props.theme.secondaryBackgroundColor};
`;

export const RouteItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 6px;
    width: 100%;
    margin-bottom: 8px;
    padding: 16px;
    && {
        background-color: ${(props) => props.theme.secondaryBackgroundColor};
        border: 1px solid ${(props) => props.theme.secondaryBorderColor};
    }
`;

export const StyledScrollContainer = styled(Flex)`
    overflow-y: auto;
    min-height: 0;
    height: 100%;
    padding: 16px;
    padding-bottom: 0;
`;

export const StyledControlsContainer = styled.div`
    position: relative;
    margin-top: auto;
    padding: 16px;
    flex-shrink: 1;
`;
